/** 
  Circuit Scramble Admin Portal Routes
*/

// Dashboard React layouts
import Dashboard from "layouts/dashboard";
import ClassicLevel from "layouts/classic";
import CreateClassicLevel from "layouts/classic/Create";
import PublicLevel from "layouts/public";
import PendingPublicLevel from "layouts/pending";
import CoinTopups from "layouts/topups";
import Creators from "layouts/creators";
import Users from "layouts/users";
import MissionsManagement from "layouts/missions";
import SubscribersManagement from "layouts/subscribers";
import FeedbacksManagement from "layouts/feedbacks";

import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";

// Dashboard icons
import { IoIosDocument, IoIosMail, IoIosChatboxes } from "react-icons/io";
import { BsFillPersonFill, BsCoin } from "react-icons/bs";
import { IoStatsChart } from "react-icons/io5";
import { IoHome } from "react-icons/io5";
import { FaUsers, FaUserTie } from "react-icons/fa";
import { MdOutlinePendingActions, MdOutlineFactCheck } from "react-icons/md";
import { SiLevelsdotfyi } from "react-icons/si";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <IoHome size="15px" color="inherit" />,
    component: Dashboard,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "User Feedbacks",
    key: "feedbacks",
    route: "/feedbacks",
    icon: <IoIosChatboxes size="17px" color="inherit" />,
    component: FeedbacksManagement,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Daily Missions",
    key: "missions",
    route: "/missions",
    icon: <MdOutlineFactCheck size="17px" color="inherit" />,
    component: MissionsManagement,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Email Subscribers",
    key: "subscribers",
    route: "/subscribers",
    icon: <IoIosMail size="17px" color="inherit" />,
    component: SubscribersManagement,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Pending Approvals",
    key: "pending",
    route: "/pending",
    icon: <MdOutlinePendingActions size="15px" color="inherit" />,
    component: PendingPublicLevel,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Coin Top-Ups",
    key: "topups",
    route: "/topups",
    icon: <BsCoin size="15px" color="inherit" />,
    component: CoinTopups,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Creators",
    key: "creators",
    route: "/creators",
    icon: <FaUserTie size="15px" color="inherit" />,
    component: Creators,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Classic Campaign",
    key: "classic",
    route: "/classic",
    icon: <SiLevelsdotfyi size="15px" color="inherit" />,
    component: ClassicLevel,
    noCollapse: true,
  },
  {
    type: "no-collapse",
    name: "Classic-Level Create",
    key: "create_classic",
    route: "/classic/create",
    icon: <SiLevelsdotfyi size="15px" color="inherit" />,
    component: CreateClassicLevel,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Public Levels",
    key: "public",
    route: "/public",
    icon: <IoStatsChart size="15px" color="inherit" />,
    component: PublicLevel,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    route: "/users",
    icon: <FaUsers size="15px" color="inherit" />,
    component: Users,
    noCollapse: true,
  },

  { type: "title", title: "Account & Admin", key: "account-pages" },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    route: "/profile",
    icon: <BsFillPersonFill size="15px" color="inherit" />,
    component: Profile,
    noCollapse: true,
  },
  {
    type: "no-collapse",
    name: "Sign In",
    key: "sign-in",
    route: "/authentication/sign-in",
    icon: <IoIosDocument size="15px" color="inherit" />,
    component: SignIn,
    noCollapse: true,
  },
];

export default routes;
